import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertStateService {
  private disableAllSubject = new BehaviorSubject<boolean>(false);

  get disableAll$(): Observable<boolean> {
    return this.disableAllSubject.asObservable();
  }

  setDisableAll(state: boolean): void {
    this.disableAllSubject.next(state);
  }
}
